import { UpfrontPaymentMethod } from '@shared/enums/payment-type';
import { ContractTypeData } from '../../models/contract.model';
import { OrderCaptureItem } from '@sales/models/sps-order-item.model';

export class SetOrderServiceIdAction {
  static readonly type = '[Order] Set order service Id';
  constructor(public orderServiceId: number) {}
}

export class SetOrderCaptureIdAction {
  static readonly type = '[Order] Set order capture Id';
  constructor(public orderCaptureId: number) {}
}

export class SetOrderPaymentTypeAction {
  static readonly type = '[Order] Set payment type for order';
  constructor(public upfrontPaymentMethod: UpfrontPaymentMethod) {}
}

export class SetUpfrontPaymentContactNumberAction {
  static readonly type = '[Order] Set payment contact number for order';
  constructor(public upfrontPaymentContactNumber: string) {}
}

export class SetSalesPersonAction {
  static readonly type = '[Order] Set sales person for order';
  constructor(public salesPersonId: string) {}
}

export class PlaceOrderFailedAction {
  static readonly type = '[Order] Place order failed';
  constructor(public errors: string[]) {}
}

export class PlaceOrderErrorAction {
  static readonly type = '[Order] Place order error';
  constructor(public errors: string[]) {}
}

export class ResetOrderAction {
  static readonly type = '[Order] Reset state';
}

export class ClearPlaceOrderErrorAction {
  static readonly type = '[Order] Clear place order error';
}

export class GenerateOrderContractAction {
  static readonly type = '[Order API] Generate correct contract and set on order';
  constructor(
    public orderCaptureItem: OrderCaptureItem,
    public contractSigningMethod: ContractTypeData
  ) {}
}

export class SetContractSigningMethodAction {
  static readonly type = '[Order] Set contract signing method';
  constructor(public contractSigningMethod: ContractTypeData) {}
}

export class SetContractSigningMethodPhoneAction {
  static readonly type = '[Order] Set contract signing method phone';
  constructor(public customerPhoneNumber: string) {}
}

export class GeneratePaperContractAction {
  static readonly type = '[Contract API] Create Paper-contract';
  constructor(public orderCaptureId: number) {}
}

export class GenerateOtherContractAction {
  static readonly type = '[Contract API] Create Other-contract';
  constructor(public orderCaptureId: number) {}
}

export class GenerateSmsContractAction {
  static readonly type = '[Contract API] Create SMS-contract';
  constructor(
    public orderCaptureId: number,
    public msisdn: string
  ) {}
}

export class SetIsServiceOrderAction {
  static readonly type = '[Order] Set is Service Order';
  constructor(public isServiceOrder: boolean) {}
}

export class UpdateProductIdentifiersForMsisdns {
  static readonly type = '[Order] Update Product Identifiers for Msisdns';
  constructor(public msisdn: string) {}
}

export class SetBankIdMsisdnAction {
  static readonly type = '[Order] Set BankID Msisdn';
  constructor(public bankIdMsisdn: string) {}
}
export class SetBankIdEmailAction {
  static readonly type = '[Order] Set BankID Email';
  constructor(public bankIdEmail: string) {}
}

export class ResetBankIdMsisdnAction {
  static readonly type = '[Order] Reset BankID Msisdn';
}

export class ResetBankIdEmailAction {
  static readonly type = '[Order] Reset BankID Email';
}

export class SetBankIdBypassNote {
  static readonly type = '[Order] Set BankID Bypass note';
  constructor(public bankIdBypassNote: string) {}
}

export class ToggleIsBankIdBypassed {
  static readonly type = '[Order] Toggle BankID-bypass';
  constructor(public isBankIdBypassed: boolean) {}
}
